import { GetLiveClassDetailsByIdDocument, GetLiveClassDetailsByIdQuery, GetLiveClassDetailsByIdQueryVariables } from '../types';
import { client } from '../../client';

export async function getLiveClassByID(variables: GetLiveClassDetailsByIdQueryVariables): Promise<GetLiveClassDetailsByIdQuery> {
  try {
    const response = await client.query<GetLiveClassDetailsByIdQuery, GetLiveClassDetailsByIdQueryVariables>({
      query: GetLiveClassDetailsByIdDocument,
      variables,
    });

    return response.data;
  } catch (e) {
    throw e;
  }
}
